import { css } from '@emotion/react';
import reset from './reset';
// import datePicker from './date-picker';

const global = css`
  :root {
    --vh: 1vh;
  }
  ${reset.styles}
  button {
    border: none;
    background: none;
    cursor: pointer;
    padding: 0;
  }

  body {
  }
`;

export default global;
